export default __webpack_public_path__ + "static/media/long-distance-different-size-dots.ba0b7829.svg";